export default "__VITE_ASSET__ycdDOqHs__"